import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { 
  M05_MODULE_INFO, 
  M05_TOPICS, 
  getAllM05Problems 
} from '../data/mathExercises/M05_PercentageMethod.js';

const M05PercentageExercise = ({ onProgress }) => {
  const topics = M05_TOPICS;
  const problems = getAllM05Problems();
  const moduleInfo = M05_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m05-exercise"
    />
  );
};

export default M05PercentageExercise; 